import { LOCALE_ID, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfirmationService, ConfirmDialogModule, GrowlModule, TooltipModule } from 'primeng/primeng';
// import {TooltipModule} from 'primeng/tooltip';
import { SelectModule } from 'ng-select';
// Service
import { DialogModule } from 'primeng/components/dialog/dialog';
import { HelperModule } from '../../../common/helper/helper.module';
import { UploadService } from '../../../common/services/Upload.service';
import { EvsAddressService } from '../../../common/services/EvsAddress.service';
import { QrCodeModule } from '../qrcode/batchstamp/qr-code/qr-code.module';
import { ExportService } from '../../../common/services/Export.service';
import { BusinessService } from '../../../common/services/Business.service';
import { WarningModule } from '../qrcode/warning/warning.module';
import { WarrantyReminderModule } from '../../../common/components/warranty-reminder/warranty-reminder.module';

// Component
import { StaffListComponent } from './business/staff-list.component';
import { OwnerListComponent } from './business/owner-list.component';
import { StampActiveForReleaseComponent } from './stamp/stamp-active-for-release.component';
import { LogStampActiveReleaseComponent } from './stamp/log-stamp-active-release.component';
import { ActiveGuaranteeComponent } from './guarantee/active-guarantee.component';
import { LogsGuaranteeComponent } from './guarantee/logs-guarantee.component';
import { StampDistributionComponent } from './stamp/stamp-distribution.component';
import { BusinessProfileComponent } from './business/business-profile.component';
import { SettingComponent } from './business/setting.component';
import { SettingActiveProductComponent } from './business/setting-active-product.component';
import { SettingSaleComponent } from './business/setting-sale.component';
import { SettingSaleBussinessComponent } from './business/setting-sale-bussiness.component';
import { SettingSaleAgencyComponent } from './business/setting-sale-agency.component';
import { SettingViewProductComponent } from './business/setting-view-product.component';
import { SettingRetargetComponent } from './business/setting-retarget/setting-retarget.component'
import { BusinessContactComponent } from './business/business-contact/business-contact.component';
import { ChangePasswordComponent } from './business/change-password.component';
import { StampEvsDashboardComponent } from './statistics/stamp-evs-dashboard.component';
import { ChartsModule } from 'ng2-charts';
import { Page401Component } from './page-error/page-401-component';
import { CancelStampComponent } from './stamp/cancel-stamp.component';
import { FindStampBySerialComponent } from './stamp_list/find-stamp-by-serial.component';
import { CardModule } from '../../../layout/card';
import { BlockModule } from '../../../layout/block';
import { ModalModule } from 'ngx-bootstrap/modal';
import { FilterProductsModule } from '../../../layout/filter-products/filter-products.module';
import { FilterProductVariantsModule } from '../../../layout/filter-product-variants/filter-product-variants.module';
import { ModalSetRoleComponent } from './business/modalSetRole.component';
import { GroupByPipe } from './business/group-by.pipe';
import { BsDatepickerModule } from 'ngx-bootstrap';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { GuaranteeAddComponent } from './guarantee/guarantee-add.component';
import { GuaranteeSettingComponent } from './guarantee/guarantee-setting/guarantee-setting.component';
import { PrintComponent } from './guarantee/print/print.component';
import { ModalManagerComponent } from './business/modal-manager/modal-manager.component';
import { CustomerManagerComponent } from './business/modal-manager/customer-manager/customer-manager.component';
import { DistributionManagerComponent } from './business/modal-manager/distribution-manager/distribution-manager.component';
import { LogManagerComponent } from './business/modal-manager/log-manager/log-manager.component';
import { ImageService } from '../../imageService';
import { AssignComponent } from './business/modal-manager/assign/assign.component';
import { StampBoxComponent } from './stamp_list/stamp-box/stamp-box.component';
import { StampProductComponent } from './stamp_list/stamp-product/stamp-product.component';
import { AgmCoreModule } from '@agm/core';
import { AgmDirectionModule } from 'agm-direction';
import { HistoryBoxModule } from '../qrcode/history-box/history-box.module';
import { ModalCratingBoxComponent } from './stamp_list/stamp-box/modal-crating-box/modal-crating-box.component';
import { BoxRetalStampsModule } from '../qrcode/share/boxRetalStamps/boxRetalStamps.module';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { StoreSaleService } from './store_manager/store-sale/services/store-sale.service';
import { StatisticsDistributedComponent } from './statistics-distributed/statistics-distributed.component';
import { PrintGuaranteeComponent } from './guarantee/print-guarantee/print-guarantee.component';
import { DistributionServiceComponent } from './business/distribution-service.component';
import { StatisticsAntiCounterfeitingComponent } from './statistics-anti-counterfeiting/statistics-anti-counterfeiting.component';
import { TranslateModule } from '@ngx-translate/core';
import { SettingOtpComponent } from './business/setting-otp/setting-otp.component';
import { SettingMarketSurveyComponent } from './business/setting-market-survey/setting-market-survey.component';
import { GuaranteeRequestListComponent } from './guarantee/guarantee-request-list.component';
import { SettingAssignmentComponent } from './business/setting-assignment/setting-assignment.component';
import { SettingMarketInspectionComponent } from './business/setting-market-inspection/setting-market-inspection.component';


import { ComponentsModule } from '../../../components/components.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    ConfirmDialogModule,
    GrowlModule,
    DialogModule,
    TooltipModule,
    BrowserModule,
    HelperModule,
    SelectModule,
    ChartsModule,
    CardModule,
    BlockModule,
    ModalModule.forRoot(),
    BsDatepickerModule.forRoot(),
    TypeaheadModule.forRoot(),
    WarrantyReminderModule,
    QrCodeModule,
    FilterProductsModule,
    FilterProductVariantsModule,
    AgmCoreModule,
    AgmDirectionModule,
    HistoryBoxModule,
    BoxRetalStampsModule,
    TabsModule.forRoot(),
    TranslateModule.forChild(),
    WarningModule,
    ComponentsModule
  ],
  declarations: [
    StaffListComponent,
    OwnerListComponent,
    ModalSetRoleComponent,
    GroupByPipe,
    ModalManagerComponent,
    CustomerManagerComponent,
    DistributionManagerComponent,
    LogManagerComponent,
    StampActiveForReleaseComponent,
    CancelStampComponent,
    LogStampActiveReleaseComponent,
    StampEvsDashboardComponent,
    ActiveGuaranteeComponent,
    LogsGuaranteeComponent,
    GuaranteeAddComponent,
    GuaranteeSettingComponent,
    PrintComponent,
    StampDistributionComponent,
    BusinessProfileComponent,
    SettingComponent,
    SettingActiveProductComponent,
    SettingSaleComponent,
    SettingSaleBussinessComponent,
    SettingSaleAgencyComponent,
    SettingViewProductComponent,
    SettingRetargetComponent,
    DistributionServiceComponent,
    BusinessContactComponent,
    ChangePasswordComponent,
    Page401Component,
    FindStampBySerialComponent,
    AssignComponent,
    StampBoxComponent,
    StampProductComponent,
    ModalCratingBoxComponent,
    StatisticsDistributedComponent,
    PrintGuaranteeComponent,
    StatisticsAntiCounterfeitingComponent,
    StatisticsAntiCounterfeitingComponent,
    SettingOtpComponent,
    SettingMarketSurveyComponent,
    GuaranteeRequestListComponent,
    SettingAssignmentComponent,
    SettingMarketInspectionComponent
  ],
  exports: [],
  providers: [
    UploadService,
    ExportService,
    EvsAddressService,
    ImageService,
    BusinessService,
    { provide: LOCALE_ID, useValue: 'vi-VI' },
    ConfirmationService,
    StoreSaleService
  ],
  entryComponents: [ModalSetRoleComponent, ModalManagerComponent],
})
export class EVSModule {
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/EVSModule.ts